import React, { useState } from "react";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/mzdozkwz";

const Contact = () => {
	const [form, setForm] = useState({ nombre: "", email: "", mensaje: "" });
	const [enviado, setEnviado] = useState(false);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError(false);
		try {
			const res = await fetch(FORMSPREE_ENDPOINT, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify(form),
			});
			if (res.ok) {
				setEnviado(true);
				setForm({ nombre: "", email: "", mensaje: "" });
			} else {
				setError(true);
			}
		} catch {
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	return (
		<section className="contact" id="contacto">
			<div className="container">
				<div className="contact__inner">
					<div className="contact__info">
						<span className="section-tag section-tag--light">
							come thru
						</span>
						<h2 className="section-title contact__title">
							ready for your{" "}
							<span className="text-accent-light">dossis</span>?
						</h2>
						<p className="contact__text">
							pásate al café, mándanos un DM o escríbenos. siempre
							hay una buena taza con tu nombre.
						</p>

						<div className="contact__details">
							<div className="contact__detail">
								<span className="contact__detail-icon">📍</span>
								<div>
									<strong>Ubicación</strong>
									<p>
										Av. Humberto Lobo 238-L101
										<br />
										Del Valle, San Pedro Garza García, N.L.
									</p>
								</div>
							</div>
							<div className="contact__detail">
								<span className="contact__detail-icon">🕐</span>
								<div>
									<strong>Horario</strong>
									<p>
										Lun–Sáb: 7:30am – 8pm
										<br />
										Domingo: Cerrado
									</p>
								</div>
							</div>
							<div className="contact__detail">
								<span className="contact__detail-icon">📸</span>
								<div>
									<strong>Instagram</strong>
									<p>
										<a
											href="https://www.instagram.com/dailydossis/"
											target="_blank"
											rel="noopener noreferrer"
											style={{ color: "inherit" }}
										>
											@dailydossis
										</a>
									</p>
								</div>
							</div>
							<div className="contact__detail">
								<span className="contact__detail-icon">✉️</span>
								<div>
									<strong>Correo</strong>
									<p>
										<a
											href="mailto:info@dailydossis.com"
											style={{ color: "inherit" }}
										>
											info@dailydossis.com
										</a>
									</p>
								</div>
							</div>
						</div>
					</div>

					<div className="contact__form-wrapper">
						{enviado ? (
							<div className="contact__success">
								<span className="contact__success-icon">
									✨
								</span>
								<h3>¡recibido!</h3>
								<p>
									Te contestamos pronto. Mientras, ya tienes
									excusa para un café.
								</p>
								<button
									className="btn btn--teal"
									onClick={() => setEnviado(false)}
								>
									Send another
								</button>
							</div>
						) : (
							<form
								className="contact__form"
								onSubmit={handleSubmit}
							>
								<h3 className="contact__form-title">
									say hi 👋
								</h3>
								<div className="contact__field">
									<label htmlFor="nombre">Nombre</label>
									<input
										id="nombre"
										type="text"
										name="nombre"
										value={form.nombre}
										onChange={handleChange}
										placeholder="¿Cómo te llamas?"
										required
									/>
								</div>
								<div className="contact__field">
									<label htmlFor="email">Correo</label>
									<input
										id="email"
										type="email"
										name="email"
										value={form.email}
										onChange={handleChange}
										placeholder="tu@correo.com"
										required
									/>
								</div>
								<div className="contact__field">
									<label htmlFor="mensaje">Mensaje</label>
									<textarea
										id="mensaje"
										name="mensaje"
										value={form.mensaje}
										onChange={handleChange}
										placeholder="Cuéntanos qué traes en mente: pedido especial, evento, collab..."
										rows={5}
										required
									/>
								</div>
								{error && (
									<p
										style={{
											color: "#E84023",
											fontSize: "14px",
											marginBottom: "8px",
										}}
									>
										Algo falló al enviar. Intenta de nuevo,
										porfa.
									</p>
								)}
								<button
									type="submit"
									className="btn btn--orange btn--full"
									disabled={loading}
								>
									{loading ? "Enviando..." : "send it"}
								</button>
							</form>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
